import { useSyncExternalStore } from 'react';

const STORAGE_KEY = 'handoff:notifications:enabled';

const listeners = new Set<() => void>();

function read(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

function emit(): void {
  for (const listener of listeners) listener();
}

export function getNotificationsEnabled(): boolean {
  return read();
}

export function setNotificationsEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  } catch {}
  emit();
}

function subscribe(callback: () => void): () => void {
  listeners.add(callback);
  const onStorage = (event: StorageEvent) => {
    if (event.key === STORAGE_KEY) callback();
  };
  window.addEventListener('storage', onStorage);
  return () => {
    listeners.delete(callback);
    window.removeEventListener('storage', onStorage);
  };
}

export function useNotificationsEnabled(): boolean {
  return useSyncExternalStore(subscribe, read, () => false);
}
